export default function PaginaNaoEncontrada() {
    return (
      <div className="w-screen h-screen flex flex-col justify-center items-center bg-gray-100">
        {/* Ilustração / Ícone */}
        <div className="mb-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-32 h-32 text-gray-500"
          >
            <path d="M3 12h3M21 12h-3M12 3v3M12 21v-3M8.3 8.3l-2.1-2.1M15.7 8.3l2.1-2.1M8.3 15.7l-2.1 2.1M15.7 15.7l2.1 2.1"></path>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
        </div>
        {/* Mensagem Principal */}
        <h1 className="text-6xl font-bold text-gray-800 mb-4 text-center">
          404
        </h1>
        <p className="text-xl text-gray-600 text-center mb-6">
          Oops! Página não encontrada.
        </p>
  
        {/* Botão de Retorno */}
        <a
          href="/home"
          className="px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-lg shadow-md transition duration-300"
        >
          Voltar para a página inicial
        </a>
      </div>
    );
  }
  